module.exports = __webpack_public_path__ + "static/kentpark-case-study-811ebfaef0426298b7bed0d885c1182e.webp";